import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';

import { FileManagerLibFINComponent } from '../../file-manager-lib-fin/file-manager-lib-fin.component';

import { URLs } from 'src/environments/constants';


import { Annexe_ID } from 'src/app/Interfaces/Libraries/Library-FIN-int/Create_WF/WorkFlow_FIN.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { User_CDMS } from 'src/app/Interfaces/Interfaces-Global/User_CDMS.interface';
import { Permission_Folder_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Permissions/Permission_FIN.interface';
import { FILE_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/File_FIN.interface';
import { FILE_CAP_Annexe_ID } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { File_Selected_To_Move_FIN, SidebarEvent } from 'src/app/Interfaces/Libraries/Library-FIN-int/Tree-Move-FIN.interface';
import { Task_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/All-Task-FIN.interface';

@Component({
  selector: 'app-context-menu-prcfin',
  templateUrl: './context-menu-prcfin.component.html',
  styleUrls: ['./context-menu-prcfin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css'],
  standalone: false
})
export class ContextMenuPRCFINComponent extends FileManagerLibFINComponent implements OnChanges {

  @Input() override Permission_FMF!: Permission_Folder_FIN;
  @Input() override FFIN_Select_CM!: FILE_FIN;
  @Input() override All_FAF_FIN!: FILE_FIN[];
  @Input() override IsMultiSelectMode: boolean = false;
  @Input() override SelectedALL_FAF_FIN: FILE_FIN[] = [];


  @Output() IsChangeFIN = new EventEmitter<boolean>();
  @Output() SelectForMoveEvent = new EventEmitter<FILE_FIN>();
  @Output() PreviewFileEvent = new EventEmitter<FILE_FIN>();
  @Output() DeleteMultipleEvent = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    this.EnaOrDis_Optional_Reviewers();
  }



  /** Solo visible en móviles/tablets (pantalla ≤ 1024px o dispositivo táctil) */
  override get isMobileDevice(): boolean {
    return window.innerWidth <= 1024 || ('ontouchstart' in window);
  }


  public FormFINProperties: FormGroup = new FormGroup({
    NameFIN: new FormControl('', [Validators.required, Validators.pattern(/^[^\\/:*?"<>|]*$/)]),
    Purpose: new FormControl({ value: '', disabled: false }, [Validators.pattern(/^[a-zA-Z0-9+ ñÑ.áéíóúÁÉÍÓÚäëïöüÄËÏÖÜüÜ,()\-:;/_'\s\u0301\u0303\u0308]{5,}/), Validators.required]),
    Revision_No: new FormControl({ value: 0, disabled: false }, [Validators.required, Validators.pattern(/^([1-9]$|[1-9][0-9]$)/)]),
    Code: new FormControl({ value: '', disabled: false }, Validators.required),
    Approver1: new FormControl({ value: '', disabled: false }, Validators.required),
    Approver2: new FormControl({ value: '', disabled: false }, Validators.required),
    Approver3: new FormControl({ value: '', disabled: false }, Validators.required),
    Approver4: new FormControl({ value: '', disabled: false }, Validators.required),

  });

  //+===================== FORM REASON REJECT =====================+\\
  public FormReject: FormGroup = new FormGroup({
    ReasonText: new FormControl('', [Validators.required, Validators.minLength(5)])
  })

  public Task_FIN: Task_FIN = {
    ID: 0,
    ID_WF: 0,
    ID_UR: -1,
    ID_Involved_User: 0,
    Status: 0,
    Date_Start: null,
    Name: '',
    NameUser: '',
    Route_Destination: '',
    Annexes: []
  };



  //&===================== FUNCTIONS FOR CONTEXT-MENU-CLICK =====================&\\


  //-================== FUNCTION FOR CLOSE CONTEXT MENU ==================-\\
  public Close_Context_Menu(): void {
    const Context_Menu = document.getElementById('Context-Menu') as HTMLDivElement;
    Context_Menu.classList.remove('active');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const Context_Menu = document.getElementById('Context-Menu') as HTMLDivElement;
    if (Context_Menu && Context_Menu.classList.contains('active')) {
      const clickedInside = Context_Menu.contains(event.target as Node);
      if (!clickedInside) {
        this.Close_Context_Menu();
      }
    }
  }

  //-================== FUNCTIONS FOR RENAME FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR OPEN OR CLOSE MODAL RENAME ==============\\
  public ToggleModalRename(CloseOrOpen: boolean): void {
    this.FillNameFormRFD();
    const ModalRenameFD = document.getElementById('ModalRenameFD') as HTMLDivElement;
    CloseOrOpen ? ModalRenameFD.classList.add('active') : ModalRenameFD.classList.remove('active');
  }

  // ============== FUNCTION FOR FILL NAME IN FORM ==============\\
  private FillNameFormRFD(): void {
    this.FormRenameFD.reset();
    let NameFoD: string;
    if (this.FFIN_Select_CM.Directory) {
      NameFoD = this.FFIN_Select_CM.Name;
    } else {
      let Name_Split: string[] = this.FFIN_Select_CM.Name.split('.'); Name_Split.pop();
      NameFoD = Name_Split.join('.');
    }
    this.FormRenameFD.controls['NameRename'].setValue(NameFoD);
  }

  // ============== FUNCTION TO CHECK IF A FILE OR DIRECTORY IS RENAMED ==============\\
  public RenameFD(): void {

    this.FFIN_Select_CM.Directory ? (this.RenameDirectory()) : (this.RenameFileFIN());

  }

  // ============== FUNCTION TO RENAME DIRECTORY ==============\\
  private RenameDirectory(): void {

    const NewNameCom = this.FormRenameFD.controls['NameRename'].value;
    const IsExistinPath = this.Check_FIN_in_Path_Directory(NewNameCom, this.FFIN_Select_CM.ID);

    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puede renombrar la carpeta con este nombre `,
        text: `¡La carpeta ya existe en este directorio!`,
        confirmButtonColor: this.ColorConfirm
      })
    } else if (this.FormRenameFD.valid) {

      const FINComp = this.FFIN_Select_CM;
      const ID_FINC = FINComp.ID;

      const NewName = String(this.FormRenameFD.get('NameRename')?.value).trim();


      Swal.fire({
        title: `Renombrar carpeta`,
        text: `¿Usted está seguro de cambiar el nombre de la carpeta?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, renombrar! '
      }).then(async (result: any) => {

        if (result.isConfirmed) {

          try {
            const ResRenameFolder: any = await firstValueFrom(this.Service_FIN.Rename_Folder({ ID: ID_FINC, NewName: NewName }));


            if (ResRenameFolder.success) {
              Swal.fire({
                title: 'Carpeta renombrada',
                text: '¡La carpeta se renombró correctamente!',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              });
            }

            this.ToggleModalRename(false);
            this.IsChangeFIN.emit(true);

          } catch (e) {

            Swal.fire({
              title: 'Error al renombrar',
              text: '¡Error al renombrar carpeta, notifique a su supervisor!',
              icon: 'error',
              confirmButtonColor: this.ColorConfirm
            })
            this.ToggleModalRename(false);
            this.IsChangeFIN.emit(true);
          }

        }
      })

    } else {
      Swal.fire({
        title: 'Nombre no valido',
        text: `¡No se permiten los siguientes caracteres \ / : * ? " < > | !`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }


  }

  // ============== FUNCTION FOR RENAME FILE ==============\\
  private RenameFileFIN(): void {

    const NewNameCom = this.FormRenameFD.controls['NameRename'].value + '.' + this.FFIN_Select_CM.Extension;
    const IsExistinPath = this.Check_FIN_in_Path_Directory(NewNameCom, this.FFIN_Select_CM.ID);


    if (IsExistinPath) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: `No puede renombrar el Proceso con este nombre `,
        text: `¡El Proceso ya existe en este directorio!`,
        confirmButtonColor: this.ColorConfirm
      })
    } else if (this.FormRenameFD.valid) {

      const FINComp = this.FFIN_Select_CM;
      const ID_FINC = FINComp.ID;

      const NewName = this.FormRenameFD.controls['NameRename'].value + '.' + this.FFIN_Select_CM.Extension;

      Swal.fire({
        title: `Renombrar Proceso`,
        text: `¿Está seguro de cambiar el nombre del Proceso?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, renombrar! '
      }).then(async (result: any) => {

        if (result.isConfirmed) {
          try {

            const ResRenameFileFIN: any = await firstValueFrom(this.Service_FIN.Rename_File_FIN({ ID: ID_FINC, NewName: NewName }));

            if (ResRenameFileFIN.success) {
              Swal.fire({
                title: 'Proceso Renombrado',
                text: '¡El Proceso se renombró correctamente!',
                icon: 'success',
                confirmButtonColor: this.ColorConfirm
              })
            }

            this.ToggleModalRename(false);
            this.IsChangeFIN.emit(true);

          } catch (e) {

            Swal.fire({
              title: 'Error al renombrar',
              text: '¡Error al renombrar el Proceso, notifique a su supervisor!',
              icon: 'error',
              confirmButtonColor: this.ColorConfirm
            })
            this.ToggleModalRename(false);
            this.IsChangeFIN.emit(true);
          }
        }

      })

    } else {
      Swal.fire({
        title: '¡Nombre no valido!',
        text: `No se permiten los siguientes caracteres \ / : * ? " < > |`,
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }
  }

  //-================== FUNCTION TO APPROVED FOR ADMINISTRATOR ==================-\\
  public Approve_FIN_For_Admin(): void {

    if (this.FFIN_Select_CM.Status != 2) {

      let Status: string = '';

      (this.FFIN_Select_CM.Status === 1) ? (Status = 'aprobado') : (Status = 'rechazado')

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No puede aprobar este Proceso',
        text: `¡El Proceso seleccionada ya fue ${Status}!`,
        confirmButtonColor: this.ColorConfirm,
      })
    } else {
      Swal.fire({
        title: '¿Está Seguro de Aprobar el Proceso?',
        text: "¡Los revisores ya no podrán revisar este Proceso!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, aprobar!'
      }).then(async (result) => {
        if (result.isConfirmed) {


          try {

            const ResApprovedAdmin: any = await firstValueFrom(this.Service_FIN.Approve_FIN_To_Admin({ ID_WF: this.FFIN_Select_CM.ID }));

            if (ResApprovedAdmin.success) {
              Swal.fire({
                icon: 'success',
                title: 'Proceso Aprobado',
                text: '¡El Proceso se aprobó correctamente!',
                confirmButtonColor: this.ColorConfirm,
              })
            }

            this.IsChangeFIN.emit(true);

          } catch (e) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: '¡Ocurrió un error al aprobar el Proceso!',
              confirmButtonColor: this.ColorConfirm,
            })
            this.IsChangeFIN.emit(true);
          }

        }
      })
    }
  }

  //-================== FUNCTION TO REJECT FOR ADMINISTRATOR ==================-\\
  public Reject_FIN_For_Admin(): void {
    if (this.FFIN_Select_CM.Status != 2) {
      let Status: string = '';

      (this.FFIN_Select_CM.Status === 1) ? (Status = 'aprobado') : (Status = 'rechazado')

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'No puede rechazar este Proceso',
        text: `¡El Proceso seleccionada ya fue ${Status}!`,
        confirmButtonColor: this.ColorConfirm,
      })
    } else {

      this.Task_FIN.ID = this.FFIN_Select_CM.ID;
      this.ToggleModalReasonReject(true);
    }
  }

  //-================== FUNCTION TO SEE VERSION HISTORY ==================-\\
  public CanSeeVersionHistory(): boolean {
    return !this.FFIN_Select_CM?.Directory
      && (this.UserRoleIn([this.PermissionFIN.versionHistory])
        || this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN]));
  }

  public See_version_History(): void {
    if (!this.CanSeeVersionHistory()) {
      Swal.fire('Acción no permitida', 'No tienes permisos para ver el historial de versiones.', 'warning');
      return;
    }

    window.open(`${URLs.URLINDEX}/Dashboard/FIN/History/${this.FFIN_Select_CM.ID}/${this.Permission_FMF.Folder.ID}`)
  }

  //-================== FUNCTION TO PROPERTIES ==================-\\


  public IsCompleteProperties($event: any) {
    if ($event) {
      this.IsChangeFIN.emit(true);
    }
  }


  public isUpdateAnnexe($event: any) {
    if ($event) {
      this.Fill_Properties();
    }
  }

  // ============== FUNCTION FOR OPEN OR CLOSE MODAL PROPERTIES ==============\\
  public async ToggleModalProperties(CloseOrOpen: boolean): Promise<void> {

    const ModalPropertiesFIN = document.getElementById('ModalPropertiesFIN') as HTMLDivElement;

    if (CloseOrOpen) {

      if (await this.Fill_Properties()) {
        this.EnaOrDis_Optional_Reviewers();
        ModalPropertiesFIN.classList.add('active')
      } else {
        this.Reset_Form_Properties();
      }

    } else {
      ModalPropertiesFIN.classList.remove('active');
      this.Reset_Form_Properties();
    }

  }

  public EnaOrDis_Optional_Reviewers() {

    if (this.Permission_FMF.Folder.Optional_Approvers === 0) {
      this.FormFINProperties.controls['Approver1'].setValidators(Validators.required);
      this.FormFINProperties.controls['Approver2'].setValidators(Validators.required);
      this.FormFINProperties.controls['Approver3'].setValidators(Validators.required);
      this.FormFINProperties.controls['Approver4'].setValidators(Validators.required);
    } else {
      if (!this.Permission_FMF.Users_Groups_For_Role.G_Approvers_1.gApproverFolderFIN.Required_RG)
        this.FormFINProperties.controls['Approver1'].removeValidators(Validators.required);
      if (!this.Permission_FMF.Users_Groups_For_Role.G_Approvers_2.gApproverFolderFIN.Required_RG)
        this.FormFINProperties.controls['Approver2'].removeValidators(Validators.required);
      if (!this.Permission_FMF.Users_Groups_For_Role.G_Approvers_3.gApproverFolderFIN.Required_RG)
        this.FormFINProperties.controls['Approver3'].removeValidators(Validators.required);
      if (!this.Permission_FMF.Users_Groups_For_Role.G_Approvers_4.gApproverFolderFIN.Required_RG)
        this.FormFINProperties.controls['Approver4'].removeValidators(Validators.required);
    }

    this.FormFINProperties.get('Approver1')?.updateValueAndValidity();
    this.FormFINProperties.get('Approver2')?.updateValueAndValidity();
    this.FormFINProperties.get('Approver3')?.updateValueAndValidity();
    this.FormFINProperties.get('Approver4')?.updateValueAndValidity();

  }

  // ============== FUNCTION RESET FORM PROPERTIES ==============\\
  private Reset_Form_Properties(): void {
    this.FileAuxPropeties_Anne = [];
    this.FileAuxUpdFIN_Annexe_Properties = { ID: 0, FileData: '', FileName: '', Extension: '', Status: 0, Consecutive: 0, UpdateAnnexe: { FileData: '', FileName: '', Extension: '' } };
    this.FormFINProperties.reset();
    this.FILE_FIN_Properties = {
      ID: 0,
      Name: '',
      Extension: '',
      Code: '',
      Purpose: '',
      Revision_No: 0,
      Status: 0,
      Area: null,
      Shop: null,
      ID_Folder: 0,
      TaskApprover1: {
        ID: 0,
        ID_WF: 0,
        ID_Involved_User: 0,
        ID_UR: 0,
        Status: 0,
        Comment: null,
        Date_Start: null,
        Date_End: null,
      },
      TaskApprover2: {
        ID: 0,
        ID_WF: 0,
        ID_Involved_User: 0,
        ID_UR: 0,
        Status: 0,
        Comment: null,
        Date_Start: null,
        Date_End: null,
      },
      TaskApprover3: {
        ID: 0,
        ID_WF: 0,
        ID_Involved_User: 0,
        ID_UR: 0,
        Status: 0,
        Comment: null,
        Date_Start: null,
        Date_End: null,
      },
      TaskApprover4: {
        ID: 0,
        ID_WF: 0,
        ID_Involved_User: 0,
        ID_UR: 0,
        Status: 0,
        Comment: null,
        Date_Start: null,
        Date_End: null,
      },
      Date_Created: null,
      Date_Modification: null,
      Date_Expiration: null,
      Date_End: null,
      ID_Contributor: 0,
      ID_Previous_Version: null,
      ID_Next_Version: null,
      Status_System: 0,
      Annexes: [],
      Approver1_Name: '',
      Approver2_Name: '',
      Approver3_Name: '',
      Approver4_Name: '',
      Contributor_Name: '',
      Directory: false,
      Path: null,
      Summary: ''
    }
  }

  // ============== FUNCTION FILL FORM PROPERTIES ==============\\
  private async Fill_Properties(): Promise<boolean> {
    try {

      const ResDataFIN: Response_FIN = await firstValueFrom(this.Service_FIN.Get_Info_Of_FIN({ ID_FIN: this.FFIN_Select_CM.ID }));

      if (ResDataFIN.success) {
        this.FILE_FIN_Properties = ResDataFIN.operation;

        const TaskApprover1 = this.FILE_FIN_Properties.TaskApprover1 || { ID_Involved_User: -1 };
        const TaskApprover2 = this.FILE_FIN_Properties.TaskApprover2 || { ID_Involved_User: -1 };
        const TaskApprover3 = this.FILE_FIN_Properties.TaskApprover3 || { ID_Involved_User: -1 };
        const TaskApprover4 = this.FILE_FIN_Properties.TaskApprover4 || { ID_Involved_User: -1 };

        const UserApprover1: User_CDMS = { ID: TaskApprover1.ID_Involved_User ?? -1, Name: this.FILE_FIN_Properties.Approver1_Name ?? '' };
        const UserApprover2: User_CDMS | string = TaskApprover2.ID_Involved_User != -1 ? { ID: TaskApprover2.ID_Involved_User, Name: this.FILE_FIN_Properties.Approver2_Name ?? '' } : '';
        const UserApprover3: User_CDMS | string = TaskApprover3.ID_Involved_User != -1 ? { ID: TaskApprover3.ID_Involved_User, Name: this.FILE_FIN_Properties.Approver3_Name ?? '' } : '';
        const UserApprover4: User_CDMS = { ID: TaskApprover4.ID_Involved_User ?? -1, Name: this.FILE_FIN_Properties.Approver4_Name ?? '' };


        let Name_FIN: string[] = this.FILE_FIN_Properties.Name.split('.');
        Name_FIN.pop();

        const NameFIN_Clean: string = Name_FIN.join('.');

        this.FormFINProperties.controls['NameFIN'].setValue(NameFIN_Clean)
        this.FormFINProperties.controls['Purpose'].setValue(this.FILE_FIN_Properties.Purpose)
        this.FormFINProperties.controls['Revision_No'].setValue(this.FILE_FIN_Properties.Revision_No)
        this.FormFINProperties.controls['Code'].setValue(this.FILE_FIN_Properties.Code)
        this.FormFINProperties.controls['Approver1'].setValue(UserApprover1)
        this.FormFINProperties.controls['Approver2'].setValue(UserApprover2)
        this.FormFINProperties.controls['Approver3'].setValue(UserApprover3)
        this.FormFINProperties.controls['Approver4'].setValue(UserApprover4)

        const Annexes_FIN: Annexe_ID[] = this.FILE_FIN_Properties.Annexes;

        const Annexes_CAP: FILE_CAP_Annexe_ID[] = [];

        for (const Annexe of Annexes_FIN) {
          Annexes_CAP.push({ ID: Annexe.ID, FileData: '', FileName: Annexe.Name, Extension: Annexe.Extension, Status: 0, Consecutive: 0, UpdateAnnexe: { FileName: '', FileData: '', Extension: '' } });
        }

        this.FileAuxPropeties_Anne = Annexes_CAP;

      }
      return true;

    } catch (e) {
      Swal.fire({
        icon: 'warning',
        title: 'Error al abrir las propiedades',
        text: '¡No se cargó correctamente la data del proceso, notifica a tu supervisor!',
        confirmButtonColor: this.ColorConfirm
      });
      return false;
    }
  }

  //-================== FUNCTION TO DELETE A FILE OR DIRECTORY ==================-\\

  // ============== FUNCTION FOR VERIFY IF FILE SELECT IS FILE OR DIRECTORY ==============\\
  public Delete_File_or_Directory(): void {
    const isMultiple = this.IsMultiSelectMode && 
                       Array.isArray(this.SelectedALL_FAF_FIN) && 
                       this.SelectedALL_FAF_FIN.some((i: any) => i.ID === this.FFIN_Select_CM.ID);

    if (isMultiple) {
      this.DeleteMultipleEvent.emit();
    } else {
      this.FFIN_Select_CM.Directory ? (this.Delete_Directory_FIN()) : (this.Delete_File_FIN());
    }
  }

  // ============== FUNCTION FOR DELETE FILE FIN ==============\\
  private Delete_File_FIN(): void {

    Swal.fire({
      title: '¿Está seguro de eliminar el Proceso?',
      text: "¡Enviara el Proceso a papelera de reciclaje!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Marque la casilla para eliminar el Proceso!`,
          input: 'checkbox',
          inputPlaceholder: 'Eliminar Proceso',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async (result2: any) => {

          if (result.isConfirmed) {

            if (result2.value === 1) {

              console.log('Objeto seleccionado:', this.FFIN_Select_CM); // Revisa qué propiedades tiene realmente
              console.log('ID que se enviará:', this.FFIN_Select_CM.ID);
              try {

                const ResMoveRBin: any = await firstValueFrom(this.Service_FIN.Move_FIN_To_Recycle_Bin({ ID_WF: this.FFIN_Select_CM.ID_WF }));

                if (ResMoveRBin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Proceso eliminado',
                    text: '¡Se elimino correctamente el Proceso!',
                    confirmButtonColor: this.ColorConfirm
                  });
                }

                this.IsChangeFIN.emit(true);

              } catch (e) {
                Swal.fire({
                  icon: 'warning',
                  title: 'Error al eliminar el Proceso',
                  text: '¡No se eliminó el Proceso, notifica a tu supervisor!',
                  confirmButtonColor: this.ColorConfirm
                });

                this.IsChangeFIN.emit(true);
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para eliminar el Proceso!',
                confirmButtonColor: this.ColorConfirm
              });

              this.IsChangeFIN.emit(true);
            }

          }


        }))
      }
    })

  }

  // ============== FUNCTION FOR DELETE DIRECTORY ==============\\
  private Delete_Directory_FIN(): void {

    const NameDelete: string = (this.FFIN_Select_CM.Name).trim();

    Swal.fire({
      title: '¿Está seguro de eliminar esta carpeta?',
      text: "¡No podrá revertir cambios!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: this.ColorConfirm,
      cancelButtonColor: this.ColorsCancel,
      confirmButtonText: '¡sí, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Nuevamente ¿está seguro?',
          text: `¡Para eliminar la carpeta escriba ${NameDelete} !`,
          input: 'text',
          confirmButtonText: 'Continuar <i class="fa-solid fa-right-long"></i>',
          confirmButtonColor: this.ColorConfirm,
          cancelButtonColor: this.ColorsCancel,
          showCancelButton: true,
        }).then((async result2 => {

          if (result2.isConfirmed) {

            const ValueInput: string = result2.value;

            if (ValueInput.toLowerCase() === NameDelete.toLowerCase()) {


              try {

                const ResDeleteFolder: any = await firstValueFrom(this.Service_FIN.Delete_Folder({ ID_Folder: this.FFIN_Select_CM.ID }));

                Swal.fire({
                  icon: 'success',
                  title: 'Carpeta eliminada',
                  text: '¡Se eliminó correctamente la carpeta!',
                  confirmButtonColor: this.ColorConfirm
                })
                this.IsChangeFIN.emit(true);

              } catch (error) {
                Swal.fire({
                  title: 'Ocurrió un error',
                  text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.IsChangeFIN.emit(true);
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin coincidencia',
                text: '¡Escriba correctamente el nombre del directorio para eliminarlo!',
                confirmButtonColor: this.ColorConfirm
              })
            }
          }
        }))
      }
    })
  }

  //-================== FUNCTION TO CHECK IF USER CAN DOWNLOAD ==================-\\
  // Admin, permiso de carpeta, contribuidor o aprobador del documento
  public CanDownloadCM(): boolean {
    const IsAdmin = this.UserService.UserRoleGeneralIn([this.RolesGeneral.AdministratorFIN, this.RolesGeneral.SuperAdministrator]);
    const HasFolderDownloadPermission = this.UserRoleIn([this.PermissionFIN.downloadVersionFlow]);
    const IsContributor = Number(this.ID_User_BD) === Number(this.FFIN_Select_CM.ID_Contributor);
    const IsApprover = (this.FFIN_Select_CM.DynamicApprovers || []).some((a: any) => a.ID_Involved_User === Number(this.ID_User_BD));
    return IsAdmin || HasFolderDownloadPermission || IsContributor || IsApprover;
  }

  //-================== FUNCTION TO DOWNLOAD FILE ==================-\\
  public DownloadFile(): void {

    this.DownloadTable(this.FFIN_Select_CM);

  }


  //-================== FUNCTION FOR SAVE REASON REJECT ==================-\\
  public SaveReject(): void {

    const IsValidForm = this.ValidationFormReject();

    if (this.FormReject.valid && IsValidForm) {

      const Reason: string = this.FormReject.controls['ReasonText'].value;

      Swal.fire({
        title: '¿Desea enviar la razón de rechazo?',
        text: `¡No podrá revertir cambios!`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: this.ColorConfirm,
        cancelButtonColor: this.ColorsCancel,
        confirmButtonText: '¡Sí, enviar!',
        cancelButtonText: 'No, cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Nuevamente ¿está seguro?',
            text: `¡Marque la casilla para confirmar el envió de la razón de rechazo!`,
            input: 'checkbox',
            inputPlaceholder: 'Enviar razón de rechazo',
            confirmButtonText: 'Continuar <i class="fa-solid fa-arrow-right"></i>',
            confirmButtonColor: this.ColorConfirm,
            cancelButtonColor: this.ColorsCancel,
            showCancelButton: true,
          }).then(async (resultRem) => {

            if (resultRem.value === 1) {

              try {

                const ResRejectAdmin: any = await firstValueFrom(this.Service_FIN.Reject_FIN_To_Admin({ ID_WF: this.FFIN_Select_CM.ID, Reason: Reason }));

                if (ResRejectAdmin.success) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Proceso rechazado',
                    confirmButtonColor: this.ColorConfirm,
                  })
                  this.ToggleModalReasonReject(false);
                  this.IsChangeFIN.emit(true);
                }

              } catch (e) {
                Swal.fire({
                  title: 'Ocurrió un error al rechazar la tarea',
                  text: '¡Notifique este error al supervisor!',
                  icon: 'warning',
                  confirmButtonColor: this.ColorConfirm
                })
                this.ToggleModalReasonReject(false);
                this.IsChangeFIN.emit(true);
              }

            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Sin confirmar',
                text: '¡Marque la casilla para enviar la razón de rechazo !',
                confirmButtonColor: this.ColorConfirm
              })
            }
          })
        }
      })
    }
  }

  //-================== FUNCTION FOR VALIDATE FORM ==================-\\
  private ValidationFormReject(): boolean {

    const IdTextAreaRejectFIN = document.getElementById('IdTextAreaRejectFIN') as HTMLTextAreaElement; IdTextAreaRejectFIN.classList.remove('Is-Invalid-Form');

    if (!this.FormReject.controls['ReasonText'].valid) {
      IdTextAreaRejectFIN.classList.add('ng-invalid'); IdTextAreaRejectFIN.classList.add('ng-touched');

      if (this.FormReject.controls['ReasonText'].value == '') {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡Ingresa una razón de rechazo!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      } else {
        Swal.fire({
          title: 'Razón no valida',
          text: `¡La razón de rechazo es muy corta!`,
          icon: 'warning',
          confirmButtonColor: this.ColorConfirm
        })
        return false;
      }

    }

    return true;
  }

  //-================== FUNCTION FOR OPEN OR CLOSE MODAL REASON REJECT ==================-\\
  public ToggleModalReasonReject(CloseOrOpen: boolean): void {
    const ModalReject = document.getElementById('ModalReject') as HTMLDivElement;
    CloseOrOpen ? ModalReject.classList.add('active') : ModalReject.classList.remove('active');
  }

  //&===================== END FUNCTIONS FOR CONTEXT-MENU-CLICK =====================&\\

}
